var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    viewBox: "0.5 1 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.25h-3.5A1.75 1.75 0 001.5 5v8.75a1.75 1.75 0 001.75 1.75H12a1.75 1.75 0 001.75-1.75v-3.5m-3.5-8.75h5.25m0 0v5.25m0-5.25l-8.75 8.75",
    stroke: "#2D3748",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/updateAccount.d9830d15.svg";
export { SvgUpdateAccount as ReactComponent };